export default __webpack_public_path__ + "images/HP.df9cea1.png";